// @flow

import * as React from "react";
import {
  blue,
  lightblue,
  white,
  red,
  grey,
  black,
  lightred,
  lightgrey,
} from "./_colors";
import { style, classes } from "typestyle";

type ButtonType = "primary" | "secondary" | "control" | "danger" | "disabled";
type ButtonSize = "big" | "medium";
interface IButtonProps {
  label?: string;
  icon?: React.JSX.Element;
  onClick?: (ev: React.MouseEvent<HTMLButtonElement>) => void;
  type?: ButtonType;
  size?: ButtonSize;
  className?: string;
  disabled?: boolean;
  stretched?: boolean;
}
const Button = ({
  size,
  stretched,
  type,
  label,
  icon,
  onClick,
  className,
  disabled,
}: IButtonProps) => {
  return (
    <button
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
      className={classes(
        style({
          outline: "none",
          fontSize: size === "big" ? "20px" : "14px",
          fontWeight: 500,
          lineHeight: "24px",
          whiteSpace: "nowrap",
          border: 0,
          cursor: disabled ? "auto" : "pointer",
          minWidth: label ? "72px" : "0px",
          width: size === "big" || stretched ? "100%" : "auto",
          height: size === "big" ? "56px" : "auto",
          boxShadow:
            size === "big"
              ? "0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12)"
              : "none",
          padding: "8px 16px",
          borderRadius: "12px",
          background: getBackgroundColorByType(type, disabled),
          color: getTextColorByType(type, disabled),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          $nest: {
            "&>*:nth-child(2)": {
              // this style will work when both icon and label are visible
              paddingLeft: "8px",
            },
          },
        }),
        className || "",
      )}
    >
      {icon || null}
      {label && <span>{label}</span>}
    </button>
  );
};

export default Button;

function getBackgroundColorByType(type?: ButtonType, disabled?: boolean) {
  if (disabled) {
    return lightgrey;
  }

  switch (type) {
    case "primary":
      return blue;
    case "danger":
      return lightred;
    case "control":
      return white;
    case "secondary":
    default:
      return lightblue;
  }
}

function getTextColorByType(type?: ButtonType, disabled?: boolean) {
  if (disabled) {
    return grey;
  }

  switch (type) {
    case "primary":
      return white;
    case "control":
      return black;
    case "danger":
      return red;
    case "secondary":
    default:
      return blue;
  }
}
